import {useState, useEffect} from 'react'
import {Offcanvas, Button} from "react-bootstrap";
import i18n from "../../i18n";
import {isLargeScreen} from "../../utils/Toolbox";
import ReserveCheckoutComponent from "./ReserveCheckout.component";
import ConfirmComponent from "../Confirm.component";
import useReserveContext from "../../hooks/useReserveContext";
import {trackEvent} from "../GA.component";

type ReserveModalComponentProps = {
    btnClass?: string;
    btnVariant?: string;
}

const ReserveModalComponent = ({
 btnClass = 'p-1 ps-5 pe-5',
 btnVariant = 'primary'
 }: ReserveModalComponentProps) => {

    const {openSection, setOpenSection, showConfirmModal, setShowConfirmModal, hasError} = useReserveContext();
    const {t} = i18n;
    const [placement, setPlacement] = useState<'bottom' | 'end'>('end');
    useEffect(() => {
        const handleResize = () => {
            setPlacement(isLargeScreen() ? 'end' : 'bottom');
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (<>

        <Button variant={btnVariant} onClick={() => {
            setOpenSection(true)
            trackEvent({
                category: 'Reservation Modal',
                action: 'Open',
            });
        }} className={`${btnClass}`}>
            {t('Reserve Your PakVille Today!')}
        </Button>

        <ConfirmComponent
            bodyNode={<p
                className={`text-center p-1 ps-5 pe-5`}>{t('Your reservation isn’t complete, are you sure you want to exit?')}</p>}
            confirmLabel={t('Yes, Exit')}
            closeLabel={t('No, Continue Reserving')}
            onConfirm={() => setShowConfirmModal(false)}
            onHide={() => setShowConfirmModal(false)} // same as confirm!
            onClose={() => {
                setOpenSection(false);
                setShowConfirmModal(false)
            }}
            show={showConfirmModal}
        />

        <Offcanvas show={openSection} onHide={() => !hasError ? setShowConfirmModal(true) : {}} backdrop="static" scroll
                   placement={placement} className="reserve-modal">
            <Offcanvas.Header>
            </Offcanvas.Header>
            <Offcanvas.Body>

                {openSection &&
                    <>
                        {!hasError &&
                            <Button className='d-flex justify-content-center ms-auto reserve-modal-close-btn ' onClick={() => setShowConfirmModal(true)}>
                                &times;
                            </Button>
                }
                        <ReserveCheckoutComponent/>
                    </>

                }
            </Offcanvas.Body>
        </Offcanvas>
    </>)
}

export default ReserveModalComponent;